module.exports = __webpack_public_path__ + "static/img/horror-hand-v5.76c29759.png";